<template>
  <v-row class="mt--30 mt_sm--40">
    <!-- Start Blog Area  -->
    <v-col
      lg="4"
      md="4"
      sm="6"
      cols="12"
      v-for="(item, i) in blogContent"
      :key="i"
    >
      <div class="im_box mt--30">
        <div class="thumbnail">
          <router-link :to="'/blog-details/' + item.slug">
            <div class="image-container" style="max-height: 300px;">
              <img class="w-100" :src="item.src" alt="Blog Images" />
              <div class="image-overlay"></div>
            </div>
          </router-link>
        </div>
        <div class="content">
          <div class="inner">
            <div class="content_heading">
              <div class="category_list">
                <router-link :to="'/blog-details/' + item.slug">{{
                  item.category
                }}</router-link>
              </div>
              <h4 class="heading-title">
                <router-link :to="'/blog-details/' + item.slug">{{ item.title }}</router-link>
              </h4>
            </div>
            <div class="content_footer">
              <router-link :to="'/blog-details/' + item.slug" class="rn-btn btn-opacity">
                Ler mais
              </router-link>
            </div>
          </div>
          <router-link
            class="transparent_link"
            :to="'/blog-details/' + item.slug"
          ></router-link>
        </div>
      </div>
    </v-col>
    <!-- End Blog Area  -->
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        blogContent: [],
      };
    },
    async created() {
      await this.loadPosts();
    },
    methods: {
      async loadPosts() {
        try {
          const response = await fetch('/content/blog/posts.json');
          const posts = await response.json();
          this.blogContent = posts.map(post => ({
            src: post.thumbnail,
            title: post.title,
            category: post.category,
            slug: post.slug,
          }));
        } catch (error) {
          console.error('Error loading posts:', error);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .image-container {
    position: relative;
    overflow: hidden;
    
    img {
      display: block;
      transition: transform 0.3s ease;
    }
    
    .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.2) 50%,
        rgba(0, 0, 0, 0.3) 100%
      );
      pointer-events: none;
      transition: opacity 0.3s ease;
    }
  }
  
  /* Hover effect para melhorar a interação */
  .image-container:hover {
    img {
      transform: scale(1.05);
    }
    
    .image-overlay {
      opacity: 0.8;
    }
  }
  
  /* Ajusta o posicionamento do conteúdo sobre a imagem */
  .content {
    position: relative;
    z-index: 2;
  }
</style>
